document.addEventListener('DOMContentLoaded', () => {
  const waitPop = setInterval(() => {
    const pop = document.querySelector(".satori__popup_body a")
    if(pop !== null){
      clearInterval(waitPop)
      action()
    }
  }, 500)
})

const setHrefUrl = (baseUrl) => {
  const url = baseUrl + location.search
  document.querySelector(".satori__popup_body a").setAttribute("href", url)
}

const action = () => {
  const formbridge = document.querySelector(".satori__popup_body a").getAttribute("href")
  setHrefUrl(formbridge)

  const situation = document.querySelectorAll(".list-situation")
  situation.forEach((target) => {
    target.addEventListener('click', () => {
      setTimeout(() => {
        setHrefUrl(formbridge)
      }, 100)
    }, false)
  })

  const trouble = document.querySelectorAll(".list-trouble")
  trouble.forEach((target) => {
    target.addEventListener('click', () => {
      setTimeout(() => {
        setHrefUrl(formbridge)
      }, 100)
    }, false)
  })
}
